import { render, staticRenderFns } from "./name-bubble.vue?vue&type=template&id=4f411116&scoped=true"
import script from "./name-bubble.vue?vue&type=script&lang=js"
export * from "./name-bubble.vue?vue&type=script&lang=js"
import style0 from "./name-bubble.vue?vue&type=style&index=0&id=4f411116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f411116",
  null
  
)

export default component.exports